import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'clsx';

import viewTypes from '../../constants/unlock/viewTypes';
import UnlockActivityView from './UnlockActivityView';
import UnlockSuccessView from './UnlockSuccessView';
import UnlockFailureView from './UnlockFailureView';

import css from './unlock-view-container.module.scss';
import unlockCss from './unlock.module.scss';

class UnlockViewContainer extends Component {
  static propTypes = {
    unlockActions: PropTypes.object.isRequired,
    campaignId: PropTypes.number,
    campaignKey: PropTypes.string,
    unlockToken: PropTypes.string,
    viewType: PropTypes.string,
    isDialog: PropTypes.bool,
  };

  getViewToRender() {
    const { unlockActions, campaignId, campaignKey, unlockToken, viewType } =
      this.props;

    const commonProps = {
      unlockActions,
      campaignId,
      campaignKey,
      unlockToken,
    };

    switch (viewType) {
      case viewTypes.unlockActivity:
        return <UnlockActivityView key="unlockActivityView" {...commonProps} />;
      case viewTypes.unlockSuccess:
        return <UnlockSuccessView key="unlockSuccessView" {...commonProps} />;
      case viewTypes.unlockFailure:
        return <UnlockFailureView key="unlockFailureView" {...commonProps} />;
      default:
        return undefined;
    }
  }

  render() {
    const { isDialog } = this.props;

    return (
      <div
        ref="unlockViewContainer"
        key="unlockViewContainer"
        tabIndex="0"
        className={classNames(css.container, unlockCss.withFormSections, {
          [unlockCss.fullScreen]: !isDialog,
        })}
      >
        {this.getViewToRender()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    viewType: state.unlockDetails.viewType,
  };
}

export default connect(mapStateToProps)(UnlockViewContainer);
